export interface AdapterDefaults {
  count?: number
  sortOrder?: string
}

/**
 * Prefix of every WBS route, bound by the transport.
 * Only routes missing from the generated API tree spell it out.
 */
export const PLATFORM = '/{platform}'

export const DeviceType = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop',
} as const
export type DeviceType = (typeof DeviceType)[keyof typeof DeviceType]
